import { BaseModel } from '@/api/base-model'
import { ChecklistSettingsAPI } from '@/api/backend-client'

export class ChecklistSettings extends BaseModel<ChecklistSettings> {
    protected collectionName = ChecklistSettingsAPI.collectionName

    constructor(
        public id: string,
        public aankoopmakelaar_1_min: number,
        public aankoopmakelaar_1_max: number,
        public aankoopmakelaar_1_price: number,
        public aankoopmakelaar_2_min: number,
        public aankoopmakelaar_2_max: number,
        public aankoopmakelaar_2_price: number,
        public aankoopmakelaar_3_min: number,
        public aankoopmakelaar_3_max: number,
        public aankoopmakelaar_3_price: number,
        public aankoopmakelaar_4_min: number,
        public aankoopmakelaar_4_max: number,
        public aankoopmakelaar_4_price: number,
        public aankoopmakelaar_5_min: number,
        public aankoopmakelaar_5_max: number,
        public aankoopmakelaar_5_price: number,
        public taxatiekosten_1_min: number,
        public taxatiekosten_1_max: number,
        public taxatiekosten_1_price: number,
        public taxatiekosten_2_min: number,
        public taxatiekosten_2_max: number,
        public taxatiekosten_2_price: number,
        public taxatiekosten_3_min: number,
        public taxatiekosten_3_max: number,
        public taxatiekosten_3_price: number,
        public taxatiekosten_4_min: number,
        public taxatiekosten_4_max: number,
        public taxatiekosten_4_price: number,
        public taxatiekosten_5_min: number,
        public taxatiekosten_5_max: number,
        public taxatiekosten_5_price: number,
        public notariskosten_kk_1_min: number,
        public notariskosten_kk_1_max: number,
        public notariskosten_kk_1_price: number,
        public notariskosten_kk_2_min: number,
        public notariskosten_kk_2_max: number,
        public notariskosten_kk_2_price: number,
        public notariskosten_kk_3_min: number,
        public notariskosten_kk_3_max: number,
        public notariskosten_kk_3_price: number,
        public notariskosten_kk_4_min: number,
        public notariskosten_kk_4_max: number,
        public notariskosten_kk_4_price: number,
        public notariskosten_kk_5_min: number,
        public notariskosten_kk_5_max: number,
        public notariskosten_kk_5_price: number,
        public notariskosten_von_1_min: number,
        public notariskosten_von_1_max: number,
        public notariskosten_von_1_price: number,
        public notariskosten_von_2_min: number,
        public notariskosten_von_2_max: number,
        public notariskosten_von_2_price: number,
        public notariskosten_von_3_min: number,
        public notariskosten_von_3_max: number,
        public notariskosten_von_3_price: number,
        public notariskosten_von_4_min: number,
        public notariskosten_von_4_max: number,
        public notariskosten_von_4_price: number,
        public notariskosten_von_5_min: number,
        public notariskosten_von_5_max: number,
        public notariskosten_von_5_price: number,
        public advieskosten_1_min: number,
        public advieskosten_1_max: number,
        public advieskosten_1_price: number,
        public advieskosten_2_min: number,
        public advieskosten_2_max: number,
        public advieskosten_2_price: number,
        public advieskosten_3_min: number,
        public advieskosten_3_max: number,
        public advieskosten_3_price: number,
        public advieskosten_4_min: number,
        public advieskosten_4_max: number,
        public advieskosten_4_price: number,
        public advieskosten_5_min: number,
        public advieskosten_5_max: number,
        public advieskosten_5_price: number,
    ) { super(id) }

    static fromData(data: any): ChecklistSettings {
        if (data === null || typeof data === 'string' || data instanceof ChecklistSettings) {
            return data
        }

        return new ChecklistSettings(
            data.id,
            data.aankoopmakelaar_1_min,
            data.aankoopmakelaar_1_max,
            data.aankoopmakelaar_1_price,
            data.aankoopmakelaar_2_min,
            data.aankoopmakelaar_2_max,
            data.aankoopmakelaar_2_price,
            data.aankoopmakelaar_3_min,
            data.aankoopmakelaar_3_max,
            data.aankoopmakelaar_3_price,
            data.aankoopmakelaar_4_min,
            data.aankoopmakelaar_4_max,
            data.aankoopmakelaar_4_price,
            data.aankoopmakelaar_5_min,
            data.aankoopmakelaar_5_max,
            data.aankoopmakelaar_5_price,
            data.taxatiekosten_1_min,
            data.taxatiekosten_1_max,
            data.taxatiekosten_1_price,
            data.taxatiekosten_2_min,
            data.taxatiekosten_2_max,
            data.taxatiekosten_2_price,
            data.taxatiekosten_3_min,
            data.taxatiekosten_3_max,
            data.taxatiekosten_3_price,
            data.taxatiekosten_4_min,
            data.taxatiekosten_4_max,
            data.taxatiekosten_4_price,
            data.taxatiekosten_5_min,
            data.taxatiekosten_5_max,
            data.taxatiekosten_5_price,
            data.notariskosten_kk_1_min,
            data.notariskosten_kk_1_max,
            data.notariskosten_kk_1_price,
            data.notariskosten_kk_2_min,
            data.notariskosten_kk_2_max,
            data.notariskosten_kk_2_price,
            data.notariskosten_kk_3_min,
            data.notariskosten_kk_3_max,
            data.notariskosten_kk_3_price,
            data.notariskosten_kk_4_min,
            data.notariskosten_kk_4_max,
            data.notariskosten_kk_4_price,
            data.notariskosten_kk_5_min,
            data.notariskosten_kk_5_max,
            data.notariskosten_kk_5_price,
            data.notariskosten_von_1_min,
            data.notariskosten_von_1_max,
            data.notariskosten_von_1_price,
            data.notariskosten_von_2_min,
            data.notariskosten_von_2_max,
            data.notariskosten_von_2_price,
            data.notariskosten_von_3_min,
            data.notariskosten_von_3_max,
            data.notariskosten_von_3_price,
            data.notariskosten_von_4_min,
            data.notariskosten_von_4_max,
            data.notariskosten_von_4_price,
            data.notariskosten_von_5_min,
            data.notariskosten_von_5_max,
            data.notariskosten_von_5_price,
            data.advieskosten_1_min,
            data.advieskosten_1_max,
            data.advieskosten_1_price,
            data.advieskosten_2_min,
            data.advieskosten_2_max,
            data.advieskosten_2_price,
            data.advieskosten_3_min,
            data.advieskosten_3_max,
            data.advieskosten_3_price,
            data.advieskosten_4_min,
            data.advieskosten_4_max,
            data.advieskosten_4_price,
            data.advieskosten_5_min,
            data.advieskosten_5_max,
            data.advieskosten_5_price,
        )
    }
}
